import UnitsApi from "./../api/unitsApi";
import { getTags } from "./../utilities/unitsFilters";
export const GET_UNITS_DATA_REQUESTED = "units/GET_UNITS_DATA_REQUESTED";
export const GET_UNITS_DATA = "units/GET_UNITS_DATA";
export const CHANGE_UNITS_SELECTION = "units/CHANGE_UNITS_SELECTION";
export const GET_UNITS_DATA_REQUEST_ERROR =
  "units/GET_UNITS_DATA_REQUEST_ERROR";
export const ADD_SELECTED_TAG = "units/ADD_SELECTED_TAG";
export const REMOVE_SELECTED_TAG = "units/REMOVE_SELECTED_TAG";
export const CHANGE_SELECTED_TAGS = "units/CHANGE_SELECTED_TAGS";

const initialState = {
  data: [],
  isLoading: false,
  selectedTags: [],
  tags: [],
  selectedUnits: [], // Array of ids
  selectAll: false // boolean indicating if the select all checkbox should be checked
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_UNITS_DATA_REQUESTED:
      return {
        ...state,
        isLoading: true
      };

    case GET_UNITS_DATA:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        tags: getTags(action.data)
      };

    case GET_UNITS_DATA_REQUEST_ERROR:
      return {
        ...state,
        isLoading: false
      };

    case CHANGE_UNITS_SELECTION:
      return {
        ...state,
        selectedUnits: action.selectedUnits,
        selectAll: action.isSelectall
      };
    case ADD_SELECTED_TAG:
      return {
        ...state,
        selectedTags: [...state.selectedTags, action.tag]
      };
    case REMOVE_SELECTED_TAG:
      return {
        ...state,
        selectedTags: [...state.selectedTags.filter(tag => tag !== action.tag)]
      };

    case CHANGE_SELECTED_TAGS:
      return {
        ...state,
        selectedTags: [...action.tags]
      };

    default:
      return state;
  }
};

export const getUnitsData = config => {
  return dispatch => {
    dispatch({
      type: GET_UNITS_DATA_REQUESTED
    });

    if (process.env.NODE_ENV === "development") {
      return UnitsApi.getUnitsFake()
        .then(data => {
          dispatch({
            type: GET_UNITS_DATA,
            data: data.map(unit => {
              unit._id = unit.Unidad;
              return unit;
            })
          });
        })
        .catch(error => {
          dispatch({
            type: GET_UNITS_DATA_REQUEST_ERROR
          });
          throw error;
        });
    } else {
      return UnitsApi.getUnits()
        .then(data => {
          dispatch({
            type: GET_UNITS_DATA,
            data: data.map(unit => {
              unit._id = unit.Unidad;
              return unit;
            })
          });
        })
        .catch(error => {
          dispatch({
            type: GET_UNITS_DATA_REQUEST_ERROR
          });
          throw error;
        });
    }
  };
};

export const changeSelectedUnits = (selectedIds, isSelectall) => {
  return dispatch => {
    dispatch({
      type: CHANGE_UNITS_SELECTION,
      selectedUnits: selectedIds,
      isSelectall: isSelectall
    });
  };
};

export const addSelectedTag = tag => {
  return dispatch => {
    dispatch({
      type: ADD_SELECTED_TAG,
      tag
    });
  };
};

export const removeSelectedTag = tag => {
  return dispatch => {
    dispatch({
      type: REMOVE_SELECTED_TAG,
      tag
    });
  };
};

export const changeSelectedTags = tags => {
  return dispatch => {
    dispatch({
      type: CHANGE_SELECTED_TAGS,
      tags
    });
  };
};



// WEBPACK FOOTER //
// ./src/modules/units.js